import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Grid,
  LinearProgress,
  Typography,
  styled,
} from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import DashboardLogo from '@assets/images/dashboard/dashboard-logo.svg';
import {
  googleLogin,
  selectIsLoggingInSSO,
  userDetail,
} from '../../../../store/auth';

const Logo = styled('img')`
  height: 100%;
  max-width: 250px;
  margin: 10px;
`;

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loginError, setLoginError] = useState('');
  const isLoggingIn = useSelector(selectIsLoggingInSSO);

  const responseGoogle = (response) => {
    const { credential } = response;
    // eslint-disable-next-line consistent-return
    return dispatch(googleLogin({ token: credential })).then((resp) => {
      if (resp.payload && resp.payload.status !== 'OK') {
        setLoginError(resp.payload.message);
        return;
      }
      dispatch(userDetail()).then(() => {
        navigate('/landing');
      });
    });
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh', position: 'relative' }}>
      <Grid
        item
        xs={12}>
        <Logo
          src={DashboardLogo}
          alt="Dashboard Logo"
        />
      </Grid>
      <Grid
        item
        xs={12}>
        <>
          {isLoggingIn && <LinearProgress color="primary" />}
          <GoogleLogin
            disabled={isLoggingIn}
            onSuccess={responseGoogle}
          />
        </>
        {loginError && (
          <Alert
            severity="error"
            style={{ marginTop: 10 }}>
            {loginError}
          </Alert>
        )}
      </Grid>
      {process.env.REACT_APP_VERSION && (
        <Typography
          variant="caption"
          component="footer"
          sx={{
            position: 'absolute',
            bottom: 16,
            left: 0,
            right: 0,
            textAlign: 'center',
            color: 'text.secondary',
          }}>
          v{process.env.REACT_APP_VERSION}
        </Typography>
      )}
    </Grid>
  );
}

export default Login;
